"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var dx_react_grid_1 = require("@devexpress/dx-react-grid");
var dx_react_grid_material_ui_1 = require("@devexpress/dx-react-grid-material-ui");
var antd_1 = require("antd");
var projectsList_1 = require("common/global/projectsList");
var usersList_1 = require("common/global/usersList");
var warehousesList_1 = require("common/global/warehousesList");
var lodash_1 = require("lodash");
var index_modules_css_1 = __importDefault(require("portal/index.modules.css"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var useTitle_1 = __importDefault(require("../../../hooks/useTitle"));
var defaultDevExtremeGridComponents_1 = __importDefault(require("../../../utils/defaultDevExtremeGridComponents"));
var rolesList_1 = require("common/global/rolesList");
var reduxHooks_1 = require("portal/hooks/reduxHooks");
var warehouseRolesSlice_1 = require("src/features/warehouseRoles/warehouseRolesSlice");
var Option = antd_1.Select.Option;
function UserRoles(props) {
    var _this = this;
    var _a;
    var _b = (0, reduxHooks_1.useAppSelector)(function (state) { return state.warehouseRoles; }), warehouseRoles = _b.data, warehouseRolesStatus = _b.status;
    var currentUser = (0, reduxHooks_1.useAppSelector)(function (state) { return state.auth; }).currentUser;
    var dispatch = (0, reduxHooks_1.useAppDispatch)();
    var t = (0, react_i18next_1.useTranslation)().t;
    (0, useTitle_1.default)(props.projectId ? t("projects.projectRoles") : t("warehouse.warehouseRoles"));
    var params = (0, react_router_dom_1.useParams)();
    var warehouseId = (_a = props.warehouseId) !== null && _a !== void 0 ? _a : params.warehouseId;
    (0, react_1.useEffect)(function () {
        dispatch((0, warehouseRolesSlice_1.fetchRolesByWarehouseId)(warehouseId));
        var unsubscribe = (0, warehouseRolesSlice_1.subscribeToRoles)(dispatch);
        return function () {
            unsubscribe();
        };
    }, [dispatch, warehouseId]);
    if (warehouseRolesStatus == "loading") {
        return (0, jsx_runtime_1.jsx)("p", { children: "Waiting" });
    }
    var rolesData = Object.values(rolesList_1.globalRolesData);
    var columns = [
        {
            name: "uid",
            title: "Name",
        },
        {
            name: "roleIds",
            title: "Role",
        },
    ];
    var commitChanges = function (_a) {
        var added = _a.added, changed = _a.changed, deleted = _a.deleted;
        return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (added) {
                            dispatch((0, warehouseRolesSlice_1.addRole)(__assign(__assign({}, added[0]), { warehouseId: warehouseId })));
                        }
                        if (!changed) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.all((0, lodash_1.map)(changed, function (changedFields, docId) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    dispatch((0, warehouseRolesSlice_1.editRole)(__assign({ id: docId }, changedFields)));
                                    return [2 /*return*/];
                                });
                            }); }))];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (!deleted) return [3 /*break*/, 4];
                        return [4 /*yield*/, Promise.all(deleted.map(function (docId) {
                                dispatch((0, warehouseRolesSlice_1.deleteRole)(docId));
                            }))];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    var dataSource = (warehouseRoles !== null && warehouseRoles !== void 0 ? warehouseRoles : []).map(function (doc) {
        return __assign(__assign({}, doc), { id: doc.id });
    });
    var SelectRole = function (_a) {
        var value = _a.value, onValueChange = _a.onValueChange, row = _a.row;
        return ((0, jsx_runtime_1.jsx)(antd_1.Select
        // filterOption={(inputValue, option) => {
        //   return (
        //     (option.props.children as any)
        //       .toLowerCase()
        //       .indexOf(inputValue.toLowerCase()) >= 0
        //   );
        // }}
        , __assign({ 
            // filterOption={(inputValue, option) => {
            //   return (
            //     (option.props.children as any)
            //       .toLowerCase()
            //       .indexOf(inputValue.toLowerCase()) >= 0
            //   );
            // }}
            style: { width: "85%", marginLeft: 8 }, mode: "multiple", showSearch: true, optionFilterProp: "children", value: value, onChange: function (e) { return onValueChange(e); }, allowClear: !row }, { children: rolesData.map(function (role) {
                return ((0, jsx_runtime_1.jsxs)(Option, __assign({ value: role.id }, { children: [role === null || role === void 0 ? void 0 : role.title, " *"] }), role.id));
            }) })));
    };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: index_modules_css_1.default.profileBox }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "container" }, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)(dx_react_grid_material_ui_1.Grid, __assign({ rows: dataSource, columns: columns, getRowId: function (r) { return r.id; } }, { children: __spreadArray(__spreadArray([(0, jsx_runtime_1.jsx)(dx_react_grid_1.EditingState, { onCommitChanges: commitChanges }), (0, jsx_runtime_1.jsx)(dx_react_grid_1.DataTypeProvider, { for: ["role", "id", "minTotal", "maxTotal"], availableFilterOperations: [
                                "equal",
                                "notEqual",
                                "greaterThan",
                                "greaterThanOrEqual",
                                "lessThan",
                                "lessThanOrEqual",
                            ] }), (0, jsx_runtime_1.jsx)(dx_react_grid_1.DataTypeProvider, { for: ["uid"], editorComponent: SelectUser, formatterComponent: function (_a) {
                                var _b, _c;
                                var value = _a.value;
                                return ((0, jsx_runtime_1.jsx)("span", { children: (_c = (_b = usersList_1.globalUsersData[value]) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : "" }));
                            }, availableFilterOperations: [
                                "equal",
                                "notEqual",
                                "greaterThan",
                                "greaterThanOrEqual",
                                "lessThan",
                                "lessThanOrEqual",
                                "startsWith",
                            ] }), (0, jsx_runtime_1.jsx)(dx_react_grid_1.DataTypeProvider, { for: ["roleIds"], editorComponent: SelectRole, availableFilterOperations: [
                                "startsWith",
                                "endsWith",
                                "contains",
                                "equal",
                            ], formatterComponent: function (_a) {
                                var value = _a.value;
                                return value
                                    .map(function (v) {
                                    var _a;
                                    return (_a = rolesList_1.globalRolesData[v !== null && v !== void 0 ? v : ""]) === null || _a === void 0 ? void 0 : _a.title;
                                })
                                    .join(", ");
                            } }), (0, jsx_runtime_1.jsx)(dx_react_grid_1.DataTypeProvider, { for: ["warehouseId"], editorComponent: SelectWarehouse, formatterComponent: function (_a) {
                                var _b, _c;
                                var value = _a.value;
                                return ((0, jsx_runtime_1.jsx)("span", { children: (_c = (_b = warehousesList_1.globalWarehousesData[value]) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : "" }));
                            }, availableFilterOperations: [
                                "startsWith",
                                "endsWith",
                                "contains",
                                "equal",
                            ] }), (0, jsx_runtime_1.jsx)(dx_react_grid_1.DataTypeProvider, { for: ["projectId"], editorComponent: SelectProject, formatterComponent: function (_a) {
                                var _b, _c;
                                var value = _a.value;
                                return ((0, jsx_runtime_1.jsx)("span", { children: (_c = (_b = projectsList_1.globalProjectsData[value]) === null || _b === void 0 ? void 0 : _b.code) !== null && _c !== void 0 ? _c : "" }));
                            }, availableFilterOperations: [
                                "startsWith",
                                "endsWith",
                                "contains",
                                "equal",
                            ] })], (0, defaultDevExtremeGridComponents_1.default)({
                        allowHidingColumns: false,
                        columnExtensions: [{ columnName: "role", width: 500 }],
                    }), true), [(0, jsx_runtime_1.jsx)(dx_react_grid_material_ui_1.TableEditRow, {}), (0, jsx_runtime_1.jsx)(dx_react_grid_material_ui_1.TableEditColumn, { showAddCommand: true, showEditCommand: true, showDeleteCommand: true })], false) })) }) })) })));
}
exports.default = UserRoles;
function SelectUser(_a) {
    var value = _a.value, onValueChange = _a.onValueChange, row = _a.row;
    var data = (0, lodash_1.map)(usersList_1.globalUsersData, function (user, idx) {
        return ((0, jsx_runtime_1.jsx)(Option, __assign({ value: user.id }, { children: user.name }), idx));
    });
    return ((0, jsx_runtime_1.jsx)(antd_1.Select, __assign({ style: { width: "85%", marginLeft: 8 }, showSearch: true, optionFilterProp: "children", value: value, onChange: function (e) { return onValueChange(e); }, allowClear: !row }, { children: data })));
}
function SelectWarehouse(_a) {
    var value = _a.value, onValueChange = _a.onValueChange, row = _a.row;
    var data = (0, lodash_1.map)(warehousesList_1.globalWarehousesData, function (warehouse, idx) {
        return ((0, jsx_runtime_1.jsx)(Option, __assign({ value: warehouse.id }, { children: warehouse.name }), idx));
    });
    return ((0, jsx_runtime_1.jsx)(antd_1.Select, __assign({ style: { width: "85%", marginLeft: 8 }, mode: !row || (row === null || row === void 0 ? void 0 : row.id) ? undefined : "multiple", showSearch: true, optionFilterProp: "children", value: value, onChange: function (e) { return onValueChange(e); }, allowClear: true }, { children: data })));
}
function SelectProject(_a) {
    var value = _a.value, onValueChange = _a.onValueChange, row = _a.row;
    var data = (0, lodash_1.map)(projectsList_1.globalProjectsData, function (project, idx) {
        return ((0, jsx_runtime_1.jsx)(Option, __assign({ value: project.id }, { children: project.name }), idx));
    });
    return ((0, jsx_runtime_1.jsx)(antd_1.Select, __assign({ style: { width: "85%", marginLeft: 8 }, mode: !row || (row === null || row === void 0 ? void 0 : row.id) ? undefined : "multiple", showSearch: true, optionFilterProp: "children", value: value, onChange: function (e) { return onValueChange(e); }, allowClear: true }, { children: data })));
}
